import {
  EXPORT_EXCEL_REQUEST,CLEAR_EXCEL
} from "../types";

const initialState = {
  extensionRequests: [],

};

const excelReducer = (state = initialState, action) => {
  switch (action.type) {
    case EXPORT_EXCEL_REQUEST:
        return {
        ...state,   
        extensionRequests: action.payload||[],
      };
    case CLEAR_EXCEL:
      return initialState;

    default:
      return state;
  }
};

export default excelReducer;
